import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../../../routes/urls';
import { Content, HeaderBlock, Heading, Title, Menu as MenuDiv, HeaderBtn } from './styles';
import Button from '../../../../component/button';
import { Dropdown, DropdownItem } from '../../../../component/dropdown';
import { useMobileDevice } from '../../../../global/useMobile';
import ResponsiveHeader from '../../../../component/responsiveHeader';
import { menuAllProjectArchiveItems } from '../../../../global/row';
import { BUTTON_TYPE, ICON_BUTTON_SIZE, ICON_BUTTON_TYPE } from '../../../../global/constants';
import IconButton from '../../../../component/button/iconButton';
import { HeaderProps } from '../../../../interfaces/ProjectInterface';

const Header: React.FC<HeaderProps> = (props) => {
  const { workspaceDetails } = props;
  // Other variables
  const history = useHistory();
  const mobile = useMobileDevice();

  const renderMoreDropdown = useCallback(() => {
    const archiveItem = menuAllProjectArchiveItems[0];

    return (
      (workspaceDetails?.isAdmin || workspaceDetails?.isOwner) && (
        <Dropdown
          modalTitle='More'
          activeClassName='active'
          content={
            <IconButton
              iconName='three-dots-horizontal-icon'
              size={mobile ? ICON_BUTTON_SIZE.LARGE : ICON_BUTTON_SIZE.MEDIUM}
              variant={ICON_BUTTON_TYPE.TERTIARY}
            />
          }>
          {archiveItem && (
            <DropdownItem
              label={archiveItem.label}
              tone='primary'
              onClick={() => {
                history.push(ROUTES.ARCHIVE_PROJECT);
              }}
            />
          )}
        </Dropdown>
      )
    );
  }, [history, mobile, workspaceDetails?.isAdmin, workspaceDetails?.isOwner]);

  return (
    <>
      {!mobile ? (
        <Content>
          <HeaderBlock>
            <Heading>
              <Title>All Projects</Title>
            </Heading>
          </HeaderBlock>
          <MenuDiv>
            <HeaderBtn>
              {(workspaceDetails?.isOwner || workspaceDetails?.isAdmin) && (
                <Button
                  title='New Project'
                  variant={BUTTON_TYPE.PRIMARY}
                  onClick={() => {
                    history.push(ROUTES.CREATE_PROJECT);
                  }}
                  iconName='plus-icon'
                  iconPosition='start'
                  buttonType='button'
                  size='small'
                />
              )}
            </HeaderBtn>
            {renderMoreDropdown()}
          </MenuDiv>
        </Content>
      ) : (
        <ResponsiveHeader title='All Projects' leftElement={renderMoreDropdown()} />
      )}
    </>
  );
};

export default Header;
